module.exports = __webpack_public_path__ + "static/media/address-envelop.40dc3220.png";